"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.SigningNomosClient = void 0;
const cosmwasm_stargate_1 = require("@cosmjs/cosmwasm-stargate");
const proto_signing_1 = require("@cosmjs/proto-signing");
const stargate_1 = require("@cosmjs/stargate");
const math_1 = require("@cosmjs/math");
const tx_1 = require("cosmjs-types/cosmwasm/wasm/v1/tx");
const long_1 = __importDefault(require("long"));
const encoding_1 = require("@cosmjs/encoding");
const tx_2 = require("cosmjs-types/cosmos/staking/v1beta1/tx");
const tx_3 = require("cosmjs-types/cosmos/distribution/v1beta1/tx");
const nomosClient_1 = require("./nomosClient");
const cosmos_1 = require("../../utils/cosmos");
const cosmwasm_1 = require("../../types/cosmwasm");
function createDeliverTxResponseErrorMessage(result) {
    return `Error when broadcasting tx ${result.transactionHash} at height ${result.height}. Code: ${result.code}; Raw log: ${result.rawLog}`;
}
class SigningNomosClient extends nomosClient_1.NomosClient {
    constructor(cometClient, signer, options) {
        super(cometClient);
        const { registry = new proto_signing_1.Registry([...stargate_1.defaultRegistryTypes, ...cosmwasm_stargate_1.wasmTypes]), aminoTypes = new stargate_1.AminoTypes(Object.assign(Object.assign({}, (0, stargate_1.createDefaultAminoConverters)()), (0, cosmwasm_stargate_1.createWasmAminoConverters)())), } = options;
        this.registry = registry;
        this.aminoTypes = aminoTypes;
        this.signer = signer;
        this.broadcastTimeoutMs = options.broadcastTimeoutMs;
        this.broadcastPollIntervalMs = options.broadcastPollIntervalMs;
        this.gasPrice = options.gasPrice;
    }
    static connectWithSigner(endpoint, signer, options = {}) {
        return __awaiter(this, void 0, void 0, function* () {
            const client = yield (0, cosmos_1.connectComet)(endpoint);
            return SigningNomosClient.createWithSigner(client, signer, options);
        });
    }
    static createWithSigner(cometClient, signer, options = {}) {
        return __awaiter(this, void 0, void 0, function* () {
            return new SigningNomosClient(cometClient, signer, options);
        });
    }
    static offline(signer, options = {}) {
        return __awaiter(this, void 0, void 0, function* () {
            return new SigningNomosClient(undefined, signer, options);
        });
    }
    signAndBroadcast(signerAddress, messages, fee, memo = '') {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.communicator.send(cosmwasm_1.CosmwasmMethods.signAndBroadcast, {
                messages,
                fee,
                signerAddress,
            });
            const { txHash } = response.data;
            const result = (yield this.getTx(txHash));
            return {
                height: result.height,
                txIndex: result.txIndex,
                code: result.code,
                transactionHash: txHash,
                events: result.events,
                rawLog: result.rawLog,
                data: [],
                msgResponses: result.msgResponses,
                gasUsed: result.gasUsed,
                gasWanted: result.gasWanted,
            };
        });
    }
    instantiate(senderAddress, codeId, msg, label, fee, options = {}) {
        return __awaiter(this, void 0, void 0, function* () {
            const instantiateContractMsg = {
                typeUrl: '/cosmwasm.wasm.v1.MsgInstantiateContract',
                value: tx_1.MsgInstantiateContract.fromPartial({
                    sender: senderAddress,
                    codeId: long_1.default.fromString(new math_1.Uint53(codeId).toString()).toString(),
                    label,
                    msg: (0, encoding_1.toUtf8)(JSON.stringify(msg)),
                    funds: [...(options.funds || [])],
                    admin: options.admin,
                }),
            };
            const result = yield this.signAndBroadcast(senderAddress, [instantiateContractMsg], fee, options.memo);
            if ((0, stargate_1.isDeliverTxFailure)(result)) {
                throw new Error(createDeliverTxResponseErrorMessage(result));
            }
            const parsedLogs = stargate_1.logs.parseRawLog(result.rawLog);
            const contractAddressAttr = stargate_1.logs.findAttribute(parsedLogs, 'instantiate', '_contract_address');
            return {
                contractAddress: contractAddressAttr.value,
                logs: parsedLogs,
                height: result.height,
                transactionHash: result.transactionHash,
                events: result.events,
                gasWanted: result.gasWanted,
                gasUsed: result.gasUsed,
            };
        });
    }
    updateAdmin(senderAddress, contractAddress, newAdmin, fee, memo = '') {
        return __awaiter(this, void 0, void 0, function* () {
            const updateAdminMsg = {
                typeUrl: '/cosmwasm.wasm.v1.MsgUpdateAdmin',
                value: tx_1.MsgUpdateAdmin.fromPartial({
                    sender: senderAddress,
                    contract: contractAddress,
                    newAdmin,
                }),
            };
            const result = yield this.signAndBroadcast(senderAddress, [updateAdminMsg], fee, memo);
            if ((0, stargate_1.isDeliverTxFailure)(result)) {
                throw new Error(createDeliverTxResponseErrorMessage(result));
            }
            return {
                logs: stargate_1.logs.parseRawLog(result.rawLog),
                height: result.height,
                transactionHash: result.transactionHash,
                events: result.events,
                gasWanted: result.gasWanted,
                gasUsed: result.gasUsed,
            };
        });
    }
    clearAdmin(senderAddress, contractAddress, fee, memo = '') {
        return __awaiter(this, void 0, void 0, function* () {
            const clearAdminMsg = {
                typeUrl: '/cosmwasm.wasm.v1.MsgClearAdmin',
                value: tx_1.MsgClearAdmin.fromPartial({
                    sender: senderAddress,
                    contract: contractAddress,
                }),
            };
            const result = yield this.signAndBroadcast(senderAddress, [clearAdminMsg], fee, memo);
            if ((0, stargate_1.isDeliverTxFailure)(result)) {
                throw new Error(createDeliverTxResponseErrorMessage(result));
            }
            return {
                logs: stargate_1.logs.parseRawLog(result.rawLog),
                height: result.height,
                transactionHash: result.transactionHash,
                events: result.events,
                gasWanted: result.gasWanted,
                gasUsed: result.gasUsed,
            };
        });
    }
    migrate(senderAddress, contractAddress, codeId, migrateMsg, fee, memo = '') {
        return __awaiter(this, void 0, void 0, function* () {
            const migrateContractMsg = {
                typeUrl: '/cosmwasm.wasm.v1.MsgMigrateContract',
                value: tx_1.MsgMigrateContract.fromPartial({
                    sender: senderAddress,
                    contract: contractAddress,
                    codeId: long_1.default.fromString(new math_1.Uint53(codeId).toString()).toString(),
                    msg: (0, encoding_1.toUtf8)(JSON.stringify(migrateMsg)),
                }),
            };
            const result = yield this.signAndBroadcast(senderAddress, [migrateContractMsg], fee, memo);
            if ((0, stargate_1.isDeliverTxFailure)(result)) {
                throw new Error(createDeliverTxResponseErrorMessage(result));
            }
            return {
                logs: stargate_1.logs.parseRawLog(result.rawLog),
                height: result.height,
                transactionHash: result.transactionHash,
                events: result.events,
                gasWanted: result.gasWanted,
                gasUsed: result.gasUsed,
            };
        });
    }
    execute(senderAddress, contractAddress, msg, fee, memo = '', funds) {
        return __awaiter(this, void 0, void 0, function* () {
            const instruction = {
                contractAddress,
                msg,
                funds,
            };
            return this.executeMultiple(senderAddress, [instruction], fee, memo);
        });
    }
    executeMultiple(senderAddress, instructions, fee, memo = '') {
        return __awaiter(this, void 0, void 0, function* () {
            const msgs = instructions.map((i) => ({
                typeUrl: '/cosmwasm.wasm.v1.MsgExecuteContract',
                value: tx_1.MsgExecuteContract.fromPartial({
                    sender: senderAddress,
                    contract: i.contractAddress,
                    msg: (0, encoding_1.toUtf8)(JSON.stringify(i.msg)),
                    funds: [...(i.funds || [])],
                }),
            }));
            const result = yield this.signAndBroadcast(senderAddress, msgs, fee, memo);
            if ((0, stargate_1.isDeliverTxFailure)(result)) {
                throw new Error(createDeliverTxResponseErrorMessage(result));
            }
            return {
                logs: stargate_1.logs.parseRawLog(result.rawLog),
                height: result.height,
                transactionHash: result.transactionHash,
                events: result.events,
                gasWanted: result.gasWanted,
                gasUsed: result.gasUsed,
            };
        });
    }
    sendTokens(senderAddress, recipientAddress, amount, fee, memo = '') {
        return __awaiter(this, void 0, void 0, function* () {
            const sendMsg = {
                typeUrl: '/cosmos.bank.v1beta1.MsgSend',
                value: {
                    fromAddress: senderAddress,
                    toAddress: recipientAddress,
                    amount: [...amount],
                },
            };
            return this.signAndBroadcast(senderAddress, [sendMsg], fee, memo);
        });
    }
    delegateTokens(delegatorAddress, validatorAddress, amount, fee, memo = '') {
        return __awaiter(this, void 0, void 0, function* () {
            const delegateMsg = {
                typeUrl: '/cosmos.staking.v1beta1.MsgDelegate',
                value: tx_2.MsgDelegate.fromPartial({ delegatorAddress, validatorAddress, amount }),
            };
            return this.signAndBroadcast(delegatorAddress, [delegateMsg], fee, memo);
        });
    }
    undelegateTokens(delegatorAddress, validatorAddress, amount, fee, memo = '') {
        return __awaiter(this, void 0, void 0, function* () {
            const undelegateMsg = {
                typeUrl: '/cosmos.staking.v1beta1.MsgUndelegate',
                value: tx_2.MsgUndelegate.fromPartial({ delegatorAddress, validatorAddress, amount }),
            };
            return this.signAndBroadcast(delegatorAddress, [undelegateMsg], fee, memo);
        });
    }
    withdrawRewards(delegatorAddress, validatorAddress, fee, memo = '') {
        return __awaiter(this, void 0, void 0, function* () {
            const withdrawDelegatorRewardMsg = {
                typeUrl: '/cosmos.distribution.v1beta1.MsgWithdrawDelegatorReward',
                value: tx_3.MsgWithdrawDelegatorReward.fromPartial({ delegatorAddress, validatorAddress }),
            };
            return this.signAndBroadcast(delegatorAddress, [withdrawDelegatorRewardMsg], fee, memo);
        });
    }
    signAndBroadcastSync(signerAddress, messages, fee, memo = '') {
        return __awaiter(this, void 0, void 0, function* () {
            const { transactionHash } = yield this.signAndBroadcast(signerAddress, messages, fee, memo);
            return transactionHash;
        });
    }
    simulate(signerAddress, messages, memo) {
        return __awaiter(this, void 0, void 0, function* () {
            throw new Error('method not implemented');
        });
    }
    upload(senderAddress, wasmCode, fee, memo = '', instantiatePermission) {
        return __awaiter(this, void 0, void 0, function* () {
            throw new Error('method not implemented');
        });
    }
    instantiate2(senderAddress, codeId, salt, msg, label, fee, options = {}) {
        return __awaiter(this, void 0, void 0, function* () {
            throw new Error('method not implemented');
        });
    }
    sign(signerAddress, messages, fee, memo, explicitSignerData) {
        return __awaiter(this, void 0, void 0, function* () {
            throw new Error('method not implemented');
        });
    }
    signAmino(signerAddress, messages, fee, memo, { accountNumber, sequence, chainId }) {
        return __awaiter(this, void 0, void 0, function* () {
            throw new Error('method not implemented');
        });
    }
    signDirect(signerAddress, messages, fee, memo, { accountNumber, sequence, chainId }) {
        return __awaiter(this, void 0, void 0, function* () {
            throw new Error('method not implemented');
        });
    }
}
exports.SigningNomosClient = SigningNomosClient;
//# sourceMappingURL=signingNomosClient.js.map